import Cookies from "js-cookie";

import { TEMPORARY_isNextAuthLocalStorage } from "@/lib/localstorages";

export type RedirectToRegisteredUserParams = {
  userId: string;
};

export const redirectToRegisteredUser = ({
  userId,
}: RedirectToRegisteredUserParams) => {
  if (TEMPORARY_isNextAuthLocalStorage.get() === true) {
    Cookies.set("rlogin", userId);

    window.location.reload();

    return;
  }
};
